export default "__VITE_ASSET__KG319lM$__"